import type {ReactElement} from 'react';

export interface AudioItemProps {
  uid: string;
  /** The grid holding this item; its Delete option looks the item up and removes it there. */
  gridId?: string;
  title: string;
  duration: number;
  width?: number;
  height?: number;
  source: string;
  onTitleRenamed?: (newTitle: string) => Promise<void>;
  showThreeDots?: boolean;
  /** Shown on hover (always on small screens) at the end of the row, right before the three-dot menu. */
  trailingAction?: ReactElement;
  categories?: string[];
  className?: string;
}

export enum AudioItemDropdownItemId {
  RENAME = 'rename',
  DELETE = 'delete',
}
